// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadMainContentInputAndButton {
    margin: 0 auto;
    text-align: center;
}

.NoteTextUploadedimage {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    max-width: 50%;
}

.uploadMainContentDragAndDropContainer {
    border: 3px solid var(--LiterGrayBlue);
    border-radius: 5px;
    border-style: dashed;
}

.uploadMainImageDisplay {
    display: block;
    max-height: 15em;
    max-width: 20em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}

.uploadMainImageDisplayXButton {
    text-align: right;
}

.imageCardDisplayElementContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: auto;
}

.BlueInputFileWrap {
    display: flex;
    justify-content: center;
}

@media screen and (max-width: 320px) {
    .uploadMainImageDisplay {
        max-height: 8em;
        max-width: 15em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Templates/Upload/UploadMainContent.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;AACJ","sourcesContent":[".UploadMainContentInputAndButton {\n    margin: 0 auto;\n    text-align: center;\n}\n\n.NoteTextUploadedimage {\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 50%;\n}\n\n.uploadMainContentDragAndDropContainer {\n    border: 3px solid var(--LiterGrayBlue);\n    border-radius: 5px;\n    border-style: dashed;\n}\n\n.uploadMainImageDisplay {\n    display: block;\n    max-height: 15em;\n    max-width: 20em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n}\n\n.uploadMainImageDisplayXButton {\n    text-align: right;\n}\n\n.imageCardDisplayElementContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    height: auto;\n}\n\n.BlueInputFileWrap {\n    display: flex;\n    justify-content: center;\n}\n\n@media screen and (max-width: 320px) {\n    .uploadMainImageDisplay {\n        max-height: 8em;\n        max-width: 15em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
